export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-csv-9697890970fceef5f31a916f814528d8.svg";